/**
 * All email templates we currently need for Asia Insurance
 * TODO: this is hacked a bit, we need to come up with a proper way to handle all templates
 */

import dayjs from "dayjs"

//enums
import { paymentFrequency as paymentFrequencyEnum } from "@/forms/enums.js"

// Pdf attachments
import { policy_schedule } from "./pdf/policy_schedule.js"
import { application_form } from "./pdf/application_form.js"
import { endorsement } from "./pdf/endorsement.js"
import { benefit_schedule_en } from "./pdf/benefit_schedule_en.js"
import { benefit_schedule_ch } from "./pdf/benefit_schedule_ch.js"
import { terms_and_conditions_en } from "./pdf/terms_and_conditions_en.js"
import { terms_and_conditions_ch } from "./pdf/terms_and_conditions_ch.js"
import { cover_page } from "./pdf/cover_page.js"
import { debit_note } from "./pdf/debit_note.js"

// Sender email address
const fromEmail = "vhis@afh.hk"

// html frame for emails
const emailContent = ({
	policyNumber,
	policyHolders,
	insuredName,
	englishContent,
	chineseContent
}) => {
	return `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
	<html xmlns="http://www.w3.org/1999/xhtml">
	<head>
	<meta http-equiv="Content-Type" content="text/html; charset=UTF-8"/>
	<meta name="viewport" content="width=device-width, initial-scale=1.0"/>
		<title>	Asia Insurance Co., Limited	</title>
		<style>

			#outlook a {padding:0;}
			body{width:100% !important; -webkit-text-size-adjust:100%; -ms-text-size-adjust:100%; margin:0; padding:0;}
			.ReadMsgBody {width: 100%;}
			.ExternalClass {width:100%;}
			.backgroundTable {margin:0 auto; padding:0; width:100%;!important;}
			table td {border-collapse: collapse;}
			.ExternalClass * {line-height: 115%;}
			.im { color: #000000 !important;}

			/* End reset */
			@media screen and (max-width: 630px){

				*[class="container"] { width: 320px !important; padding:0px !important}
				*[class="mobile-column"] {display: block;}
				*[class="mob-column"] {float: none !important;width: 100% !important;}
				*[class="mobile-padding"] {padding-left:10px !important;padding-right:10px !important;}
				*[class="hide"] {display:none !important;}
				*[class="100p"] {width:100% !important; height:auto !important;}
				*[class="mobile-column-blog"] {padding-bottom:20px;display:block;}


			}
			@media screen and (max-width: 450px){
				*[class="mobhide"] {display:none !important;}
				*[class="font-bump"] {font-size:16px !important;}
				*[class="link-bump"] {font-size:21px !important;}
				*[class="100p-mob"] {width:100% !important; height:auto !important;}
			}


		</style>


	</head>

	<div >

	<body style="padding:0; margin:0; background:#efefef;">



	<table border="0" cellpadding="0" cellspacing="0" class="mobile-padding" style="margin: 0; padding: 0" width="100%">
			<tr>
				<td align="center" valign="top">
					<table border="0" cellpadding="0" cellspacing="0" class="100p" width="640">
						<tr>
							<td height="10"></td>
						</tr>
					</table>

					<table border="0" cellpadding="20" cellspacing="0" class="100p" style="background-color: #FFFFFF" width="640">
						<tr>
							<td align="center" valign="top"><img alt="" border="0" src="https://insurer-logos.oss-cn-hongkong.aliyuncs.com/flexible-width-color/logo_asia_insurance_new.png" style="display:block; width:200px!important;"></td>
						</tr>
						<tr>
							<td valign="top">
								<table border="0" cellpadding="0" cellspacing="0">
									<tr>
										<td align="left" class="font-bump" style="font-size:14px; color:#333333; font-family:Arial, Helvetica, sans-serif;">
                                            <b>${dayjs().format(
																							"DD/MM/YYYY"
																						)}</b>
											<br/><br/>
											Dear Customer,
											<br/><br/>
											Product Name: <b>Asia Unique – Family Care</b><br/>
											Policy Number: <b>${policyNumber}</b><br/>
											Policy Holder(s): <b>${policyHolders.join(", ")}</b><br/>
											Insured Person: <b>${insuredName}</b><br/>
											<hr/>
											${englishContent}
											<br/><br/>
											Should you have any queries, please do not hesitate to contact our VHIS hotline at
											3606 9361 or email to <a href="mailto:vhis@afh.hk">vhis@afh.hk</a>.
											<br/><br/>
											<b>Asia Insurance Co., Limited</b>
											<br/><br/>
											This message is automatically generated by the computer system. Please do not reply
											to the email.
											<br/><br/>
											<br/><br/>
											親愛的客戶：
											<br/><br/>
											產品名稱: <b>「延愛」</b><br/>
											保單編號：<b>${policyNumber}</b><br/>
											保單持有人：<b>${policyHolders.join(",")}</b><br/>
											受保人：<b>${insuredName}</b><br/>
											<hr/>
											${chineseContent}
											<br/><br/>
											如有任何查詢，歡迎致電VHIS專線3606 9361或電郵至<a href="mailto:vhis@afh.hk">vhis@afh.hk</a>。
											<br/><br/>
											<b>亞洲保險有限公司</b><br/>
											<b>${dayjs().format("YYYY")}年${dayjs().format("MM")}月${dayjs().format(
		"DD"
	)}日</b>
											<br/><br/>
											本訊息由電腦系統自動產生，請勿回覆電郵。
                                        </td>
									</tr>
								</table>
							</td>
						</tr>
					</table>

					<table border="0" cellpadding="0" cellspacing="0" class="100p" width="640">
						<tr>
							<td height="10"></td>
						</tr>

					</table>

				</td>
			</tr>
		</table>
	</body>
	</html>
	`
}

// Application decline letter
const decline = ({
	toEmail,
	policyNumber,
	policyHolders = [],
	insuredName,
	applicationDate,
	rejectionCodes = []
}) => {
	const englishContent = `
	We refer to your application dated (Application Date,
		${dayjs(applicationDate).format("DD/MM/YYYY")}) for
	applying "Asia Unique – Family Care" VHIS insurance plan.
	<br/><br/>
	After our underwriting, we regret to inform you that your application shall not be
	accepted due to the following reason:
	<br/><br/>
	<ul>
	${rejectionCodes.map(item => `<li>${item}</li>`).join("")}
	</ul>
	`
	const chineseContent = `
	根據閣下於(Application Date,
		${dayjs(applicationDate).format("DD/MM/YYYY")})
		遞交之「「延愛」」自願醫保計
	劃申請書，經核保後，由於以下原因，閣下的申請將不被接納，謹此致歉：
	<br/><br/>
	<ul>
	${rejectionCodes.map(item => `<li>${item}</li>`).join("")}
	</ul>
	`

	return {
		from: `${fromEmail}`,
		to: `${toEmail}`,
		subject: `Application for "Asia Unique – Family Care" 保險申請 「「延愛」」– S00027-01-000-02`,
		htmlContent: emailContent({
			policyNumber,
			policyHolders,
			insuredName,
			englishContent,
			chineseContent
		})
	}
}

/**
 * Counter offer and Endorsement letter (For loading and exclusions)
 *
 * payload === Quote/Policy data
 * context ==== updated Pricing , Exclusion and Product values
 *
 */

const counteroffer = ({ toEmail, type, payload, context }) => {
	const englishContent = `
	Thank you for purchasing "Asia Unique – Family Care" VHIS insurance plan. Your premium has been received.  Attached please find the Policy Schedule, Terms and Conditions, Benefit Schedule (including the Schedule of Surgical Procedures), Standard Premium schedule and copy of the application form for your kind attention.<br><br>
	Please open the encrypted attachments with the contact number you filled in the application form earlier.
	<br><br>
	<b>Password = your contact number.</b><br><br>
  This e-policy shall be effective and valid as the original.  Please read the content carefully and save it properly.
	`

	const chineseContent = `
	感謝您投保「延愛」自願醫保計劃，我們已收到您的保費，現附上保單資料頁、條款及細則、保障表(包括手術表)、標準保費表及申請表副本以供參考。
	<br><br>

	請以投保時提供之聯絡電話號碼開啟已加密之附件。<br><br>

  <b>密碼 = 您的聯絡電話</b><br><br>

  此電子保單與正本具同等效力，請詳細參閱及妥為保存。
	`
	// hardcoded occupation values
	const getOccupuationString = code => {
		if (code === "001") {
			return "Office worker/ Sales/ Teacher/ People whose work include only office duties/ counter or sales duties"
		}

		if (code === "002") {
			return "Doctor/ Nurse/ Dentist/ Surgeon/ workers in laboratory/ Architect/ supervising construction/ building Contractor/ Immigration Department/ Physiotherapist/ Psychiatrist"
		}

		if (code === "003") {
			return "Blue collar works/ Bus driver/ Taxi driver/ pay driver/ Cook/ Painter/ Waiter/ Waitress"
		}

		if (code === "004") {
			return "Policeman/ Fireman/ Correctional Service Department/ Truck driver/ Stevedore/ Structural Steel Worker/ Furniture Mover/ Carpenter"
		}

		if (code === "005") {
			return "Acrobat/ Jockey/ Professional Sport Players/ Construction site worker"
		}
	}

	const insuredKey = type === "quote" ? "insured" : "contractInsured"
	const holderKey = type === "quote" ? "holder" : "contractHolder"
	const otherHoldersKey =
		type === "quote" ? "otherHolders" : "otherContractHolders"

	const policyNumber = type == "quote" ? "---" : payload.issuerNumber
	const otherHolders = payload[otherHoldersKey] ? payload[otherHoldersKey] : []
	const otherHoldersNames = payload[otherHoldersKey]
		? payload[otherHoldersKey].map(item => item.name)
		: []
	const policyHolders = [payload[holderKey].name, ...otherHoldersNames]
	const insuredName = payload[insuredKey][0].name
		? payload[insuredKey][0].name
		: ""
	const issueDate =
		type === "quote" ? "---" : dayjs(payload.issueDate).format("DD/MM/YYYY")
	const startDate = payload.startDate
		? dayjs(payload.startDate).format("DD/MM/YYYY")
		: ""
	const endDate = payload.endDate
		? dayjs(payload.endDate).format("DD/MM/YYYY")
		: ""
	const renewalDate = payload.endDate
		? dayjs(payload.endDate)
				.add(1, "day")
				.format("DD/MM/YYYY")
		: ""

	const underwritingYear = payload.startDate
		? dayjs(payload.startDate).year()
		: ""
	const standardPremium = context.pricing.formattedOriginalPrice
		? context.pricing.formattedOriginalPrice.replace("HKD", "$")
		: "N/A"
	const discountRatio =
		context.pricing.appliedDiscounts.length > 0
			? context.pricing.appliedDiscounts[0].ratio
			: null

	const getDiscountAmount = () => {
		let appliedDiscounts =
			context.pricing.appliedDiscounts.length > 0
				? context.pricing.appliedDiscounts[0].flat
						.toFixed(2)
						.toString()
						.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
				: null

		if (appliedDiscounts !== null)
			return appliedDiscounts.toString().replace("-", "")
	}

	const totalPremium = context.pricing.formattedPrice
		? context.pricing.formattedPrice.replace("HKD", "$")
		: "N/A"

	const loading =
		context.pricing.loadings.length > 0
			? context.pricing.loadings
					.map(item => item.flat)
					.reduce((a, b) => {
						const total = a + b
						return total
					})
			: 0

	const holderSalutation = payload[holderKey].salutation
		? payload[holderKey].salutation
		: ""
	const holderName = payload[holderKey].name ? payload[holderKey].name : ""
	const holderHKID = payload[holderKey].identities
		? payload[holderKey].identities[0].value
		: ""
	const holderDOB = payload[holderKey].dateOfBirth
		? dayjs(payload[holderKey].dateOfBirth).format("DD/MM/YYYY")
		: ""
	const holderAddress = payload[holderKey].addresses
		? payload[holderKey].addresses
				.filter(item => item.type === "correspondenceAddress")
				.map(item => {
					const fields = JSON.parse(item.fields)
					return fields.correspondenceAddress
				})
		: "N/A"
	const holderEmail = toEmail
	const holderContact = payload[holderKey].contacts
		? payload[holderKey].contacts
				.filter(item => {
					if (item.type === "telephoneNumber") return item.value
				})
				.map(item => item.value)
		: null
	const insuredHKID = payload[insuredKey][0].identities
		? payload[insuredKey][0].identities[0].value
		: ""
	const insuredDOB = payload[insuredKey][0].dateOfBirth
		? dayjs(payload[insuredKey][0].dateOfBirth).format("DD/MM/YYYY")
		: ""
	const insuredGender = payload[insuredKey][0].gender
		? payload[insuredKey][0].gender
		: ""
	const insuredHeight = payload[insuredKey][0].facts
		? payload[insuredKey][0].facts
				.filter(item => item.type === "heightInCm")
				.map(item => item.value.stringValue)
		: "N/A"
	const insuredWeight = payload[insuredKey][0].facts
		? payload[insuredKey][0].facts
				.filter(item => item.type === "weightInKg")
				.map(item => item.value.stringValue)
		: "N/A"
	const occupationCode = payload[insuredKey][0].facts
		? payload[insuredKey][0].facts
				.filter(item => item.type === "occupation")
				.map(item => {
					return item.value.stringValue
				})
		: "N/A"
	const insuredOccupation = getOccupuationString(occupationCode[0])
	const insuredRelationship =
		payload[insuredKey][0].relationships.length > 0
			? payload[insuredKey][0].relationships[0].type
			: "Self"
	const insuredPlaceOfResidence = payload[insuredKey][0].addresses
		? payload[insuredKey][0].addresses
				.filter(item => item.type === "placeOfResidence")
				.map(item => {
					const fields = JSON.parse(item.fields)
					if (fields.address === "hong_kong") return "Hong Kong"
					else return fields.address
				})
		: "N/A"
	const remarks = context.exclusions.length > 0 ? context.exclusions : []
	const insuredFacts = payload[insuredKey][0].facts
		? payload[insuredKey][0].facts
		: []
	const currentDate = dayjs().format("DD/MM/YYYY")
	const totalAmount = context.pricing.formattedPrice
		? context.pricing.formattedPrice.replace("HKD", "$")
		: null
	const paymentFrequency = context.pricing.paymentFrequency
		? paymentFrequencyEnum
				.filter(item => item.value === context.pricing.paymentFrequency)
				.map(item => item.name)
		: "N/A"
	const agentNumber = payload.referrer ? payload.referrer.internalCode : "N/A"
	const agentName = payload.referrer ? payload.referrer.name : "N/A"

	// Applies only for policies as this number is calculated from policy
	const getDebitNumber = policyNumber => {
		// ALE/SVHIS/00024773-2019 - policy number
		let partial = policyNumber.substr(-10).split("-")
		const number = partial[0]
		const year = partial[1].substr(-2)
		return `${number}-${year}/A01-000`
	}
	const debitNumber = policyNumber ? getDebitNumber(policyNumber) : "N/A"
	const taxes = context.pricing.appliedTaxes ? context.pricing.appliedTaxes : []
	let levy = taxes.find(item => item.code === "hkIALevy")
	const levyAmount = levy ? `${levy.flat}` : null
	const levyRatio = levy.ratio
	const hasEndorsement =
		context.exclusions.length > 0
			? true
			: context.pricing.loadings.length > 0
			? true
			: false

	const originalPrice = context.pricing.originalPrice
		? context.pricing.originalPrice
		: 0

	const premiumWithLoading = originalPrice + loading

	const base64ToByteArray = base64String => {
		try {
			var sliceSize = 1024
			var byteCharacters = atob(base64String)
			var bytesLength = byteCharacters.length
			var slicesCount = Math.ceil(bytesLength / sliceSize)
			var byteArrays = new Array(slicesCount)

			for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
				var begin = sliceIndex * sliceSize
				var end = Math.min(begin + sliceSize, bytesLength)

				var bytes = new Array(end - begin)
				for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
					bytes[i] = byteCharacters[offset].charCodeAt(0)
				}
				byteArrays[sliceIndex] = bytes
			}
			return byteArrays.flat()
		} catch (e) {
			console.log("Couldn't convert to byte array: " + e)
			return undefined
		}
	}

	let output = {
		from: `${fromEmail}`,
		to: `${toEmail}`,
		subject: `Application for "Asia Unique – Family Care" 保險申請 「延愛」– S00027-01-000-02`,
		htmlContent: emailContent({
			englishContent,
			chineseContent,
			policyNumber,
			policyHolders,
			insuredName
		}),
		pdfAttachments: [
			{
				fileName: "VHIS_Standard_Plan_-_cover_page.pdf",
				password: holderContact.toString(),
				htmlContent: cover_page({
					agentNumber,
					currentDate,
					agentName,
					policyNumber,
					holderName,
					debitNumber,
					hasEndorsement
				}),
				headerSettings: {
					htmUrl:
						"https://asia--uat.s3.ap-east-1.amazonaws.com/pdfTemplates/logo_header.html",
					spacing: 25
				},
				marginSettings: {
					top: 35
				}
			},
			{
				fileName: "VHIS_Standard_Plan_-_Debit_Note.pdf",
				password: holderContact.toString(),
				htmlContent: debit_note({
					currentDate,
					policyNumber,
					debitNumber,
					agentNumber,
					paymentFrequency,
					holderName,
					holderAddress,
					startDate,
					endDate,
					premiumWithLoading,
					discountRatio: discountRatio ? `${discountRatio * 100}%` : "N/A",
					discountAmount: getDiscountAmount()
						? `$(${getDiscountAmount()})`
						: "$0.00",
					levyRatio: levyRatio ? levyRatio * 100 : "",
					levyAmount,
					totalAmount
				}),
				headerSettings: {
					htmUrl:
						"https://asia--uat.s3.ap-east-1.amazonaws.com/pdfTemplates/logo_header.html",
					spacing: 25
				},
				marginSettings: {
					top: 35
				}
			},
			{
				fileName: "VHIS_Standard_Plan_-_Policy_Schedule.pdf",
				password: holderContact.toString(),
				htmlContent: policy_schedule({
					issueDate,
					policyNumber,
					agentNumber,
					policyHolders,
					insuredName,
					startDate,
					endDate,
					renewalDate,
					underwritingYear,
					standardPremium,
					loading,
					discountRatio: discountRatio ? `${discountRatio * 100}%` : "",
					discountAmount: getDiscountAmount()
						? `$(${getDiscountAmount()})`
						: "$0.00",
					levyAmount,
					levyRatio: levyRatio ? levyRatio * 100 : null,
					totalPremium
				}),
				headerSettings: {
					htmUrl:
						"https://asia--uat.s3.ap-east-1.amazonaws.com/pdfTemplates/logo_header.html",
					spacing: 25
				},
				marginSettings: {
					top: 35
				}
			},
			{
				fileName: "VHIS_Standard_Plan_-_Application_Form.pdf",
				password: holderContact.toString(),
				htmlContent: application_form({
					holderSalutation,
					holderName,
					holderHKID,
					holderDOB,
					holderAddress,
					holderEmail,
					holderContact,
					otherHolders,
					insuredName,
					insuredHKID,
					insuredDOB,
					insuredGender,
					insuredHeight,
					insuredWeight,
					insuredOccupation,
					insuredRelationship,
					insuredPlaceOfResidence,
					insuredFacts
				}),
				headerSettings: {
					htmUrl:
						"https://asia--uat.s3.ap-east-1.amazonaws.com/pdfTemplates/logo_header.html",
					spacing: 25
				},
				marginSettings: {
					top: 35,
					bottom: 30
				}
			},
			{
				fileName: "VHIS_Standard_Plan_-_T&C_(EN).pdf",
				password: holderContact.toString(),
				bytes: base64ToByteArray(terms_and_conditions_en)
			},
			{
				fileName: "VHIS_Standard_Plan_-_T&C_(CN).pdf",
				password: holderContact.toString(),
				bytes: base64ToByteArray(terms_and_conditions_ch)
			},
			{
				fileName: "VHIS_Standard_Plan_-_Benefit_Schedule_(EN).pdf",
				password: holderContact.toString(),
				htmlContent: benefit_schedule_en,
				headerSettings: {
					htmUrl:
						"https://asia--uat.s3.ap-east-1.amazonaws.com/pdfTemplates/logo_header.html",
					spacing: 25
				},
				footerSettings: {
					center:
						"The content on this page is part of the Terms and Benefits of Certified Plan (No. S00027-01-000-02).",
					fontSize: 8,
					spacing: 20
				},
				marginSettings: {
					top: 35,
					bottom: 30
				}
			},
			{
				fileName: "VHIS_Standard_Plan_-_Benefit_Schedule_(CN).pdf",
				password: holderContact.toString(),
				htmlContent: benefit_schedule_ch,
				headerSettings: {
					htmUrl:
						"https://asia--uat.s3.ap-east-1.amazonaws.com/pdfTemplates/logo_header.html",
					spacing: 25
				},
				footerSettings: {
					center:
						"本頁內容屬於自願醫保認可產品(編號:S00027-01-000-02)的條款及保障。",
					fontSize: 8,
					spacing: 20
				},
				marginSettings: {
					top: 35,
					bottom: 30
				}
			}
		]
	}

	if (hasEndorsement === true)
		output.pdfAttachments.push({
			fileName: "VHIS_Standard_Plan_-_Counteroffer_Endorsement.pdf",
			password: holderContact.toString(),
			htmlContent: endorsement({
				issueDate,
				policyNumber,
				agentNumber,
				policyHolders,
				insuredName,
				startDate,
				endDate,
				renewalDate,
				underwritingYear,
				remarks
			}),
			headerSettings: {
				htmUrl:
					"https://asia--uat.s3.ap-east-1.amazonaws.com/pdfTemplates/logo_header.html",
				spacing: 25
			},
			marginSettings: {
				top: 35
			}
		})

	return output
}

// Policy cancellation letter
const cancellation = ({
	toEmail,
	policyNumber,
	policyHolders = [],
	insuredName,
	applicationDate
}) => {
	const englishContent = `
	Upon your request dated
	(Application Date, ${dayjs(applicationDate).format("DD/MM/YYYY")}),
	the captioned policy was cancelled with effective on
	(Term. Date, ${dayjs().format("DD/MM/YYYY")}).
	<br/><br/>
	We are thankful for all your support and look forward to serving you again in the near
	future.
	`

	const chineseContent = `
	根據閣下於(Application Date, ${applicationDate})遞交之取消保單申請，上述
	保單已於(Term. Date, ${dayjs().format("DD/MM/YYYY")})取消。
	<br/><br/>
	感謝閣下的支持，並期待在不久的將來再次為閣下服務。
	`

	return {
		from: `${fromEmail}`,
		to: `${toEmail}`,
		subject: `Application for "Asia Unique – Family Care" 保險申請 「延愛」– S00027-01-000-02`,
		htmlContent: emailContent({
			policyNumber,
			policyHolders,
			insuredName,
			englishContent,
			chineseContent
		})
	}
}

// Payment link letter
const payment = ({
	toEmail,
	policyNumber,
	policyHolders = [],
	insuredName,
	paymentLink
}) => {
	const englishContent = `
	Thank you for your patience. The underwriting process for your application has been
	completed. Please kindly proceed to the payment process by clicking into the
	following website link.
	<br/><br/>
	<a style="font-size:18px;font-weight:700;" href="${paymentLink}" title="Proceed with the payment">Proceed with the payment</a>
	<br/><br/>
	After payment, your relevant policy documents shall be sent to you by email shortly.
	<br/><br/>
	Once again, thank you for choosing Asia Insurance to be your medical insurance
	service provider.
	`

	const chineseContent = `
	多謝您耐心的等候，有關上述保單申請之核保程序已完成，請從下列網址進行
	下一步付款程序。
	<br/><br/>
	<a style="font-size:18px;font-weight:700;" href="${paymentLink}" title="付款">付款</a>
	<br/><br/>
	付款後，我們將會盡快透過電郵向您發出相關保單的文件。
	<br/><br/>
	再次感謝您選擇亞洲保險作為您的醫療保險服務提供者。
	`

	return {
		from: `${fromEmail}`,
		to: `${toEmail}`,
		subject: `Application for "Asia Unique – Family Care" 保險申請 「延愛」– S00027-01-000-02`,
		htmlContent: emailContent({
			policyNumber,
			policyHolders,
			insuredName,
			englishContent,
			chineseContent
		})
	}
}

// Acknowledgement letter for notifying the customer that the application is reffered to underwriting
const acknowledge = ({
	toEmail,
	policyNumber,
	policyHolders = [],
	insuredName
}) => {
	const englishContent = `
	Thank you for choosing Asia Insurance to be your medical insurance service provider.
	<br/><br/>
	Your application is referred to underwriting process. Please await our commissioner
	to contact.
	`

	const chineseContent = `
	感謝您選擇亞洲保險作為您的醫療保險服務提供者。
	<br/><br/>
	您的申請已進入核保程序，請等待我們的專員聯繫您。
	`

	return {
		from: `${fromEmail}`,
		to: `${toEmail}`,
		subject: `Application for "Asia Unique – Family Care" 保險申請 「延愛」– S00027-01-000-02`,
		htmlContent: emailContent({
			policyNumber,
			policyHolders,
			insuredName,
			englishContent,
			chineseContent
		})
	}
}

export { decline, counteroffer, cancellation, payment, acknowledge }
